import React, { useState, useEffect } from "react";


import { useUrlState } from "../../../helpers/useUrlState";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import moment from 'moment';
import useQuery from "../../../helpers/JIFI/useQuery";
import ReactSelect from "@shadcn/components/ui/react-select";

import superagent from 'superagent';
import { backendUrl } from "../../../helpers/consts";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from 'react-toastify';
import { Button } from "@shadcn/components/ui/button";
import { Row } from "@shadcn/components/ui/row";
import { Col } from "@shadcn/components/ui/col";
import { Card, CardContent as CardBody } from "@shadcn/components/ui/card";
import { TableSkeleton } from "@shadcn/components/ui/table";


const StockStatus = () => {
  const history = useHistory();
  const initialState = {
    orderStartDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    filterStartDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    orderEndDate: moment().format('YYYY-MM-DD'),
    filterEndDate: moment().format('YYYY-MM-DD'),
    region: 'OnlineAU'
  }
  const [stateData, setStateData] = useUrlState(initialState);
  const [refresh, setRefresh] = useState(true)
  const refreshData = () => {
    setRefresh(prev => !prev)
  }


  const handleCreateDownloadRequest = () => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    superagent
    .post(`${backendUrl}/demand/create-download-request`)
    .send({ email: user.email, regions: ['OnlineAU', 'OnlineUK', 'OnlineUS',  'RetailPacfair', 'RetailChadstone', 'RetailCollingwood', 'RetailGaleries', 'RetailNy', 'RetailQv', 'Retail80Collins', 'RetailBondi', 'RetailPitt', 'RetailJames',] })
    .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
    .set('accept', 'json')
    .on('error', (response) => {
      const code = response.status;
      history.replace(history.location.pathname, {
        errorStatusCode: code,
      });
    })
    .then((response) => {
      const code = response.status;
      if (code > 400) {
        history.replace(history.location.pathname, {
          errorStatusCode: code,
        });
      } else {

        if(response?.body) {

         if(response?.body?.['requestAt']) {

          toast.warning(`You already have a download request in progress at ${moment(response?.body?.['requestAt']).format('MMMM Do YYYY, h:mm:ss a')}, please check your inbox`);
          return
        }

        toast.success('Download request created successfully');
        }
      }
    })
    .catch((err) => {
      const errorMessage =
        err.response?.body?.message || err.message || 'Internal server error';
    });
  }

  const handleChange = (e) => {
    e.persist();
    setStateData((prevState => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
        filterStartDate: e.target.name === 'orderStartDate' ? moment(e.target.value).format('YYYY-MM-DD') : prevState.filterStartDate,
        filterEndDate: e.target.name === 'orderEndDate' ? moment(e.target.value).format('YYYY-MM-DD') : prevState.filterEndDate
      }
    }))
  };

  const { orderStartDate, orderEndDate, region } = stateData;

  const [stockStatus, stockStatusState] = useQuery({
    url: `/demand/search-stock-status`,
    refresh,
    queryData: {
      startDate: orderStartDate,
      endDate: orderEndDate,
      region
    }
  })

  const [searchTerm, setSearchTerm] = useState('')
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [parseProducts, setParsedProducts] = useState([])
  const fullSelectedProduct = parseProducts.find(product => product.id === selectedProduct?.value)
  const productOptions = parseProducts.map(product => ({ value: product.id, label: product.name }))
  const [products, productState] = useQuery({
    url: `/product/findAll`,
    refresh,
  });

  const [regions, regionsState] = useQuery({
    url: `/regionConfigs`,
    refresh,
  })  

  const regeionOptions = regions?.map(region => region.regionId)

  useEffect(() => {
    if (products && productState === 'success') {
      let tempProd = products?.data?.map(product => {
        let variants = []
        product.variants.map(variant => {
          variants.push(variant.sku)
        })
        return {
          id: product._id,
          name: product.name,
          variants,
          variantsFull: product.variants,
          category: product.category
        }
      }) || []

      tempProd = tempProd.sort((a, b) => {
        // Compare by category
        if (a.category < b.category) return -1;
        if (a.category > b.category) return 1;

        // If categories are equal, compare by name
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;

        return 0;
      });

      setParsedProducts(tempProd)
    }
  }, [products])

  const loadingState = stockStatusState === 'success' && productState === 'success'

 
  const setRegion = (val) => {
    setStateData(prev => ({
      ...prev,
      region: val
    }))
  }

  const parsedLines = stockStatus?.sort((a, b) => a._id - b._id).map(status => {
    const lines = status.lines.map((line, i) => {
      const velocity = Math.round(line.salesVelocity / line.count * 100) / 100
      if (status._id === '' || status._id === '.') {
        return undefined
      }
      if (fullSelectedProduct && !fullSelectedProduct.variants.includes(status._id)) {
        return undefined
      }
      if (searchTerm !== '' && !status._id.toUpperCase().includes(searchTerm.toUpperCase())) {
        return undefined
      }
      const product = parseProducts?.find(product => product.variants.includes(status._id))
      const fullVariant = product?.variantsFull.find(variant => variant.sku === status._id)
      return {
        sku: status._id,
        region: line._id.region,
        status: line._id.status,
        count: line.count,
        velocity,
        productCategory: product?.category,
        productName: product?.name, 
        price: (fullVariant?.shopifyData || {})[region?.replace('Online', '')]?.price,
      }
    })
    return lines
  }).flat().filter(val => val).sort((a,b) => a?.productCategory?.localeCompare(b?.productCategory))

  const csvData = [
    ['Category', 'Product', 'SKU', 'Price', 'Store', 'Status', 'No of Days', 'Sales Velocity'],
    ...(parsedLines?.map(line => [line.productCategory, line.productName, line.sku, line.price, line.region, line.status, line.count, line.velocity]) || [])
  ]

  return (
    <>
      <div className="page-content">
        <div className="w-full px-3 mx-auto xl:max-w-[85%] mb-6">
          <Breadcrumbs title="Fulfillment" breadcrumbItem="Stock Status" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col>
                      <Col>
                        <Row>
                          <Col className="sm:w-10/12" style={{paddingBottom: 8}}>
                            <div className="app-search d-none d-lg-block">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..." 
                                  value={searchTerm} 
                                  onChange={(e) => setSearchTerm(e.target.value)} 
                                />
                                <span className="bx bx-search-alt"></span>
                              </div>
                            </div>
                          </Col>
                          <Col sm="2" className="sm:w-2/12"  style={{padding: 16}}>

                              <Button onClick={handleCreateDownloadRequest} type="button" variant="secondary" className="btn-lg btn-rounded">
                              CSV
                              </Button>

                          </Col>

                        </Row>
                        <Row className="gap-4 flex-wrap">
                          <Col sm="3" className="sm:w-[23%]">
                            <div className="select2-container mb-4">
                              <label className="control-label border-black">STARTING</label>
                              <input className="form-control border-black" name="orderStartDate" value={orderStartDate || ''} onChange={handleChange} type="date" id="example-date-input" />
                            </div>
                          </Col>
                          <Col sm="3" className="sm:w-[23%]">
                            <div className="select2-container mb-4">
                              <label className="control-label">ENDING</label>
                              <input className="form-control border-black" name="orderEndDate" value={orderEndDate || ''} onChange={handleChange} type="date" id="example-date-input" />
                            </div>
                          </Col>
                          <Col sm="3" className="sm:w-[23%]">
                            <div className="select2-container mb-4">
                              <label className="control-label">Region</label>
                              <ReactSelect
                                options={ regeionOptions?.length > 0 ? [...regeionOptions?.map(val => ({ value: val, label: val })), { value: 'AllRetail', label: 'All Retail' }] : [] }
                                onChange={val => setRegion(val.value)}
                                value={{ value: region, label: region }}
                              />
                            </div>
                          </Col>
                          <Col sm="3" className="sm:w-[23%]">
                            <div className="select2-container mb-4">
                              <label className="control-label">Product</label>
                              <ReactSelect
                                options={productOptions}
                                onChange={setSelectedProduct}
                                value={selectedProduct}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Col>
                  </Row>
                  <div className="table-responsive">
                    <table className="table table-centered table-nowrap">
                      <thead className="thead-light">
                        <tr>
                          <th>Category</th>
                          <th>Product</th>
                          <th>SKU</th>
                          <th>Price</th>
                          <th>Store</th>
                          <th>Status</th>
                          <th>No of Days</th>
                          <th>Sales Velocity</th>
                        </tr>
                      </thead>
                    
                        {
                          loadingState ? (
                           <tbody>
                            { parsedLines?.map((status, i) => {
                              return <tr className="py-8" style={{ padding: '16px 0' }} key={"_line_" + `${i}_` + `${status.sku}`}>
                                <td> {status.productCategory} </td>
                                <td> {status.productName} </td>
                                <td> {status.sku} </td>
                                <td> {status.price} </td>
                                <td> {status.region} </td>
                                <td> {status.status} </td>
                                <td> {status.count} </td>
                                <td> {status.velocity} </td>
                              </tr>
                            })}
                           </tbody> 


                           
                          ) : (
                            <TableSkeleton perPage={10} columns={8} />
                          )
                        }
                  
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer/>
      </div>
    </>
  );
}

export default StockStatus;
